import classnames from 'classnames';

interface PropsType {
    selectedId: string | undefined,
    products: any[],
    onChangeProduct: (p: any) => void,
    createProduct: () => void,
    enableCreateProduct: boolean,
}

export default function ListProduct({ selectedId, products, onChangeProduct, createProduct, enableCreateProduct }: PropsType) {
    return (
        <div className='h-16 flex max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto'>
            <ul className='h-full flex items-center gap-4 overflow-x-auto'>
                {products.map((product, index: number) => {
                    const selected = selectedId === product.id;
                    return (
                        <li key={product.id}>
                            <button
                                className={
                                    classnames(
                                        "relative whitespace-nowrap py-2 px-3 text-xs font-medium text-center block rounded focus:ring-0 focus:outline-none",
                                        {
                                            "bg-red-700 text-white": selected,
                                            "border text-gray-700  hover:bg-gray-100 hover:text-gray-700": !selected,
                                        }
                                    )
                                }
                                onClick={selected ? () => { } : () => onChangeProduct(product)}
                            >
                                <span>{`Artwork ${index + 1}`}</span>
                                {product?.status === "approved" && (
                                    <span className="absolute -top-1.5 -end-1.5 w-4 h-4 flex justify-center items-center shadow bg-green-100 text-green-800 text-xs font-medium rounded-full dark:bg-green-900 dark:text-green-300">
                                        <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 12 4.7 4.5 9.3-9" />
                                        </svg>
                                    </span>
                                )}

                            </button>
                        </li>
                    );
                })}
                {enableCreateProduct && (
                    <li>
                        <button
                            className={"whitespace-nowrap bg-gray-200 flex items-center border text-gray-700  hover:bg-gray-300 hover:text-gray-700  px-3 py-2 text-xs font-medium text-center rounded focus:ring-0 focus:outline-none"}
                            onClick={createProduct}
                        >
                            <svg className="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 1v16M1 9h16" />
                            </svg>

                            Add Artwork
                        </button>
                    </li>
                )}
            </ul>
        </div>
    );
}